import React, { useState, useEffect, forwardRef } from "react";
import { useTranslation } from "react-i18next";
import { Input } from "@fragments";

const Title = forwardRef(function Title({ value, onInput }, ref) {
    const { t } = useTranslation("contentModals");
    const [_value, setValue] = useState(value);

    useEffect(() => {
        onInput(_value);
    }, [_value]);

    return (
        <Input.Text
            ref={ref}
            label={t("manageContent.fields.lessonTitle")}
            placeholder={t("manageContent.fields.lessonTitle")}
            size={100}
            value={_value}
            onInput={setValue}
            autoScroll
        />
    );
});

export default Title;
